import { render } from "./WithDescription.vue?vue&type=template&id=2c660d62"
import script from "./WithDescription.vue?vue&type=script&lang=js"
export * from "./WithDescription.vue?vue&type=script&lang=js"
script.render = render

export default script